// extracted by mini-css-extract-plugin
export var askAiIcon = "_kr-9";
export var container = "_kr-0";
export var groupSeparator = "_kr-a";
export var highlight = "_kr-4";
export var resultIcon = "_kr-5";
export var resultItem = "_kr-7";
export var resultSubtitle = "_kr-3";
export var resultTitle = "_kr-2";
export var resultsList = "_kr-1";
export var searchGroup = "_kr-6";
export var selected = "_kr-8";